export default "__VITE_ASSET__BIXeJUQM__"